import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { of } from "rxjs/observable/of";
import * as $ from "jquery";
import * as _ from "lodash";
import { EventFormCustomFormType } from "../events-screen/event-page-models/event-form-custom-form-type";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ParentEventsPageMainModalContainerComponent } from "../events-screen/parent-events-page-main-modal-container/parent-events-page-main-modal-container.component";
import { RowEventEmit } from "../events-screen/event-page-models/row-event-emit";
import { SpecificEventTypeOptions } from "../events-screen/parent-events-page/parent-event-type-options/parent-event-type-options";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "mihlol",
  templateUrl: "mihlol.component.html",
  styleUrls: ["./michlol.component.scss"],
})
export class MihlolComponent implements OnInit {
  @Input() mihlol?: any;
  @Input() base?: any;
  currentUser: any;
  totalPrice: number = 0;
  loading = false;
  model: any;
  mihlolModel: any;
  mihlolEvents: any = [];
  mihlolEventSelected: any;
  searching: boolean;
  searchingMihlol: boolean;
  searchFailed: boolean;
  updated = false;
  messages: any;
  subscriptions: Subscription[] = [];
  hideSearchingWhenUnsubscribed = new Observable(
    () => () => (this.searching = false)
  );

  constructor(
    private dataService: DataService,
    private alertService: AlertService,
    private modalService: NgbModal
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  public get specificEventTypeOptions() {
    return SpecificEventTypeOptions;
  }

  public specificEventTypeHandler($event: RowEventEmit) {
    switch ($event.action as string) {
      case "addMichlol":
        this.addNewCustomEvent(EventFormCustomFormType.Michlol);
        break;
      case "addCommonEvent":
        this.addNewEvent();
        break;
    }
  }
  public addNewEvent() {
    const modalRef: NgbModalRef = this.modalService.open(
      ParentEventsPageMainModalContainerComponent,
      ParentEventsPageMainModalContainerComponent.modalOptions
    );
    (
      modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
    ).modalEventIdInput = "new";
    (
      modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
    ).customEventType = EventFormCustomFormType.common;
  }
  public formatter = (event: { eventName: string }) => event.eventName;

  clearSearch() {
    this.model = "";
  }

  public clearSearchMihlol() {
    this.mihlolModel = "";
  }

  public dataChanged(event) {
    if (!event.added) {
      event.updated = true;
    }

    this.updated = true;
  }

  public deleteEvent(event, index) {
    if (
      this.mihlolEventSelected &&
      this.mihlolEventSelected.events &&
      this.mihlolEventSelected.events.length > index
    ) {
      if (!event.added) {
        this.mihlolEventSelected["removedEvents"].push(event);
      }
      this.mihlolEventSelected.events.splice(index, 1);
      this.updated = true;
    }
  }

  select(event) {
    //   	this.clearSearch();
    let e = event.item;
    if (this.mihlolEventSelected) {
      //check if ther are events and no such event yet
      e.added = true;
      e.isAllowed = true;
      if (
        this.mihlolEventSelected &&
        this.mihlolEventSelected.events &&
        this.mihlolEventSelected.events.length > 0
      ) {
        let isThere = false;
        this.mihlolEventSelected.events.forEach((ev) => {
          if (ev.id == e.id) {
            isThere = true;
          }
        });
        if (!isThere) {
          this.mihlolEventSelected.events.push(e);
        }
      } else {
        this.mihlolEventSelected["events"] = [e];
      }
      $(".fa.fa-times-circle").click();
      this.updated = true;

      //   			this.model = '';
    }
  }

  isPurchased(event) {
    return event.isPurchased; // && event.endReg && moment(event.endReg).isAfter(new Date());
  }

  selectMihlol(event) {
    event["removedEvents"] = [];
    this.mihlolEventSelected = event;
    this.loading = true;
    this.totalPrice = 0;
    this.dataService
      .getMihlolEvents(this.mihlolEventSelected.id, event.childId)
      .subscribe(
        (data) => {
          this.calculateTotals(data);
          this.mihlolEventSelected.events = data;
          if (
            !_.isEmpty(this.mihlolEventSelected.mihlolItems) &&
            !_.isEmpty(this.mihlolEventSelected.events)
          ) {
            this.mihlolEventSelected.events.forEach((e) => {
              e.isPurchased = true;
              let notPurchasedEvent = _.filter(
                this.mihlolEventSelected.mihlolItems,
                { eventId: e.id }
              );
              if (!_.isEmpty(notPurchasedEvent)) {
                notPurchasedEvent = notPurchasedEvent[0];
                e.isPurchased = false;
                if (notPurchasedEvent.discountPrice > 0) {
                  e.discountPrice = notPurchasedEvent.discountPrice;
                  e.finalPrice = notPurchasedEvent.finalPrice;
                  e.price = notPurchasedEvent.price;
                }
              }
            });
          }
          this.updated = false;
          this.loading = false;
        },
        (error) => {
          let body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.messages[body.statusText]
                ? this.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
          this.loading = false;
        }
      );
  }

  calculateTotals(mihlolsData) {
    this.totalPrice = 0;
    if (mihlolsData && mihlolsData.length > 0) {
      mihlolsData.forEach((d) => {
        this.totalPrice += d.mapPrice ? d.mapPrice : d.price;
      });
    }
  }

  saveMihlolEvents() {
    if (this.mihlolEventSelected) {
      this.loading = true;
      this.totalPrice = 0;
      this.dataService
        .saveMihlolEvents(
          this.mihlolEventSelected,
          this.mihlolEventSelected && this.mihlolEventSelected.childId
            ? this.mihlolEventSelected.childId
            : undefined
        )
        .subscribe(
          (data) => {
            this.calculateTotals(data.mihlolEvents);
            this.mihlolEventSelected.events = data.mihlolEvents;
            this.updated = false;
            this.loading = false;
          },
          (error) => {
            this.alertService.error(
              error && error.statusText
                ? decodeURIComponent(error.statusText)
                : error
            );
            this.loading = false;
          }
        );
    }
  }

  onMihlolInit() {
    if (this.mihlol && this.mihlol.childId) {
      this.mihlol.id = this.mihlol.eventId;
      this.selectMihlol(this.mihlol);
    }
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (this.mihlol && this.mihlol.childId) {
      this.onMihlolInit();
      this.subscriptions.push(
        this.dataService.events.subscribe((children) => {
          children.forEach((child) => {
            if (
              child.childId == this.mihlol.childId &&
              !_.isEmpty(child.events)
            ) {
              child.events.forEach((ev) => {
                //
                if (ev.eventId == this.mihlol.id) {
                  this.mihlol = ev;
                  this.onMihlolInit();
                }
              });
            }
          });
        })
      );
    } else {
      this.loading = true;
      this.dataService.getAdminEvents(1, null).subscribe(
        (data) => {
          this.loading = false;
          this.mihlolEvents = data;
        },
        (error) => {
          this.alertService.error(
            error && error.statusText
              ? decodeURIComponent(error.statusText)
              : error
          );
          this.loading = false;
        }
      );
    }
  }

  addObservable(subscription: Subscription) {
    this.subscriptions.push(subscription);
  }

  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach((subscription) => {
        subscription.unsubscribe();
      });
    }
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .filter((query: string) => query && query.length > 2)
      .do(() => (this.searching = true))
      .switchMap((term) =>
        this.dataService
          .getAdminEvents(
            2,
            term,
            this.mihlolEventSelected && this.mihlolEventSelected.childId
              ? this.mihlolEventSelected.childId
              : undefined
          )
          .do(() => (this.searchFailed = false))
          .catch(() => {
            this.searchFailed = true;
            return of([]);
          })
      )
      .do(() => (this.searching = false))
      .merge(this.hideSearchingWhenUnsubscribed);

  public addNewMichlol() {
    this.addNewCustomEvent(EventFormCustomFormType.Michlol);
  }
  public addNewCustomEvent(customEventType: EventFormCustomFormType) {
    const modalRef: NgbModalRef = this.modalService.open(
      ParentEventsPageMainModalContainerComponent,
      ParentEventsPageMainModalContainerComponent.modalOptions
    );
    (
      modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
    ).modalEventIdInput = "new";
    (
      modalRef.componentInstance as ParentEventsPageMainModalContainerComponent
    ).customEventType = customEventType;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/mihlol/mihlol.component.ts